const DataProtection = [
  {
    title: "Proteksi Jiwa",
    insurances: [
      {
        name: "AMAN",
        desc: "Asuransi cicilan dari risiko tak terduga, seperti kecelakaan, cacat permanen, dan meninggal dunia.",
        slug: "asuransi-cicilan-kredit"
      },
      {
        name: "CriticaLifeCOVER",
        desc: "Asuransi perlindungan atas risiko Meninggal Dunia atau didiagnosa menderita Penyakit Kritis.",
        slug: "CriticaLifeCOVER"
      }
    ]
  },
  {
    title: "Proteksi Rumah",
    insurances: [
      {
        name: "SANTAI",
        desc: "Asuransi perabotan rumah dari kerusakan akibat bencana alam, musibah tak terduga, serta pencurian.",
        slug: "asuransi-isi-rumah"
      }
    ]
  },
  {
    title: "Proteksi Handphone, Gadget, dan Laptop",
    insurances: [
      {
        name: "EASYCOVER",
        desc: "Asuransi handphone, gadget, dan laptop dari kerusakan tak disengaja.",
        slug: "asuransi-gadget"
      },

      {
        name: "TecProtec",
        desc: "Asuransi handphone, gadget, dan laptop dari kerusakan tak disengaja khusus produk Erajaya.",
        slug: "asuransi-barang-elektronik"
      }
    ]
  },
  {
    title: "Proteksi Kartu Kredit",
    insurances: [
      {
        name: "PROTEXI",
        desc: "Asuransi pembayaran cicilan Home Credit Card dari risiko tak terduga.",
        slug: "asuransi-tagihan-kartu-kredit"
      }
    ]
  }
];
export default DataProtection;
